import { useParams } from 'react-router-dom'
import ConfirmationPage from 'shop/pages/Order'
import { AppContentLoader, LoaderSwitcher } from 'router/loaders'

export const TrackWrapper = () => {
  const { id } = useParams()
  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <ConfirmationPage entityId={id} mode='order' />
        </LoaderSwitcher>
      )}
    </AppContentLoader>
  )
}
